import { Injectable, Inject } from "@angular/core";
import { HttpService, URI } from "../shared/http.service";
import { HttpHeaders } from "@angular/common/http";
import { ChangePasswordData, RecoverPasswordData, ResetPasswordData } from "./types";

@Injectable()
export class AccountHttpService {
  constructor(private httpService: HttpService) { }
  
  public logOut() {
    return this.httpService.post<void>(URI`/api/account/logout`, null);
  }
  
  public changePassword(data: ChangePasswordData) {
    return this.httpService.post<void>(URI`/api/account/password`, data);
  }
  
  public recoverPassword(data: RecoverPasswordData) {
    return this.httpService.post<void>(URI`/api/account/recover`, data);
  }
  
  public resetPassword(data: ResetPasswordData) {
    return this.httpService.post<void>(URI`/api/account/reset`, data);
  }
}